import { render, staticRenderFns } from "./MobileBurger.vue?vue&type=template&id=0df2fb2f&scoped=true"
import script from "./MobileBurger.vue?vue&type=script&lang=ts"
export * from "./MobileBurger.vue?vue&type=script&lang=ts"
import style0 from "./MobileBurger.vue?vue&type=style&index=0&id=0df2fb2f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df2fb2f",
  null
  
)

export default component.exports